import React from "react";
import ModalPortal from "components-new/ModalPortal";
import sass from "./tables.module.sass";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";

interface IModalFilledTablesProps {
	trigger: boolean;
	type: "pattern" | "model";
	close: () => void;
	ok: (() => void) | null;
}

const ModalFilledTables: React.FC<IModalFilledTablesProps> = ({ trigger, type, ok, close }) => {
	return trigger ? (
		<ModalPortal
			size={"sm"}
			handleClose={close}
			outSide={false}
			subtitle={"Убедитесь, что все поля таблиц заполнены"}
			title={`В ${type === "pattern" ? "шаблоне" : "модели угроз"} могут отсутствовать данные`}>
			<div className={sass.btn}>
				<Button onClick={close} variant={BUTTON_VARIANTS.OUTLINED}>
					Отмена
				</Button>
				<Button
					onClick={() => {
						ok && ok();
						close();
					}}
					variant={BUTTON_VARIANTS.CONTAINED}>
					Продолжить
				</Button>
			</div>
		</ModalPortal>
	) : null;
};

export default ModalFilledTables;
